import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';

const LargeShareButtonContainer = styled.div`
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color:${props=>props.color};
    background:white;
    width: 11rem;
    height: ${props => props.isShort? '36px' : '3rem'};
    font-size: 15px;
    white-space: nowrap;

    path{
        fill:${props=>props.color};
    }
    margin-right:${props=>props.marginRight};

    &:hover {
        color:white;
        background:${props=>props.color};

        path{
            fill:white;
        }
    }
`;

const LargeShareButton = props => (
    <LargeShareButtonContainer color={props.color} marginRight={props.marginRight} onClick={props.handleClick} isShort={props.isShort} >
        {props.children}
    </LargeShareButtonContainer>
);

LargeShareButton.propTypes = {
    color: PropTypes.string.isRequired,
    marginRight: PropTypes.string,
    handleClick: PropTypes.func,
    isShort: PropTypes.bool
};

export default LargeShareButton;
